<script lang="ts" setup>
defineProps<{ keyword: string }>();
</script>

<template>
  <div>
    <div :class="[$style.title__titleUpper, $style.titleUpper]">
      <span :class="$style['title--accent']">{{ keyword }}</span
      >の始め方を
    </div>
    <div :class="[$style.title__titleLower, $style.titleLower]">無料相談</div>
  </div>
</template>

<style lang="scss" module>
.title {
  &--accent {
    color: $color-text-and-object-accent-primary;
  }
}

.titleUpper {
  font-size: 38px;
  line-height: 38px;
}

.titleLower {
  margin-top: 8px;
  font-size: 48px;
  line-height: 48px;
}
</style>
